<script>
    import { fade, fly } from "svelte/transition";
    import { questions, readOnly } from "../scripts/stores";
    import { emptyQuestions } from "../scripts/questions";
    import { push } from "svelte-spa-router";

    export let open = false;
    export let fileName = "";

    let selectedMethod;

    function closeModal() {
        $questions = emptyQuestions;
        open = false;
    }

    $: if(selectedMethod === "read") $readOnly = true;
       else $readOnly = false;

    $: if($readOnly) console.log("Vain luku")
</script>

{#if open}
    <div class="svelte-modal" in:fly={{ duration: 200, y: 200 }} out:fade={{ duration: 200 }}>
        <button class="close-btn" on:click={ closeModal }>X</button>

        <h2>Avaa ladattu tiedosto</h2>
        <p> Tiedoston nimi: { fileName } </p>

        <select class="select select-bordered w-full max-w-xs" bind:value={ selectedMethod }>
            <option disabled="disabled">Valitse käyttöoikeudet</option> 
            <option value="read">Katselu</option> 
            <option value="modify">Katselu ja muokkaus</option> 
        </select>

        <div class="action">
            <button class="btn" on:click={ closeModal }>Peruuta</button>
            <button  class="btn btn-primary" on:click={ () => push("/form/1/1") }
                disabled={ selectedMethod === "read" || selectedMethod === "modify" ? false : true }
            > 
                Avaa kysely 
            </button> 
        </div>
    </div>
{/if}

<style>
    .svelte-modal {
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translateX(-50%) translateY(-50%);
        width: 480px;
        max-width: 85%;
        height: fit-content;
        max-height: 80%;
        padding: .8rem;
        background: #fff;
        text-align: center;
        font-size: 18px;
        overflow-y: auto;
        z-index: 300;
        border: 1px solid gray;
        border-radius: 20px;
    }
    .svelte-modal h2 {
        margin-bottom: 2rem;
    }
    .svelte-modal .action {
        display: flex;
        width: 100%;
        justify-content: space-evenly;
        justify-items: center;
        padding: 1rem .5rem;
        margin-top: 1rem;
    }
    .close-btn {
        position: absolute;
        top: 0.5rem;
        right: 1rem;
        font-weight: 600;
        border: none;
        background: none;
    }
    select {
        margin-top: 1.5rem;
    }
</style>